var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"community-button inline-box",on:{"click":_vm.goToCommunity}},[_c('v-icon',{attrs:{"font-size":"2em"}},[_vm._v("currents")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }